<div class="app-hub">
  <mis-title-bar color="primary-dark">
    <ng-container startSlot>
      <a href="https://www.incline-it.com" class="clickable incline-link" title="Link and Logo for Incline-IT"></a>
    </ng-container>
    <ng-container endSlot>
      <div class="title-bar-element-padding">
        <a class="clickable help" href="https://incline.atlassian.net" title="Help"> </a>
        <button id="logout" type="button" class="logout clickable" (click)="logout()">
          <span class="logout-text">Log Out</span>
          <div class="icon"></div>
        </button>
      </div>
    </ng-container>
  </mis-title-bar>
  <div class="content">
    @if (!applications) {
      <app-loading></app-loading>
    }
    @if (applications) {
      <span class="title">Available Applications</span>
    }
    <div class="app-grid">
      @for (application of applications; track application) {
        <mis-app-launcher
          appImageUrl="./assets/icons/{{application.applicationName}}.png" [appLaunchUrl]="application.url"
        [appTitle]="application.applicationName"></mis-app-launcher>
      }
    </div>
  </div>
</div>